import React from 'react';

const SecurePopup = props => {
  return(
      <div className={`secure-popup ${props.secureLocation}`}>
        <div className="row secure-wrapper">
          <div className="column small-12">
            <p className="secure-text">
              We use secure payment platform to process bookings. Look out
  for the green lock or domain with HTTPS in the URL address bar.
            </p>
            <div className="secure-bar">
              <div className="row secure-wrapper">
                <div className="column small-12">
                  <img src="https://images.contentful.com/3ng3kfj0qs70/7gdq6gayNUAos4qK460Gw6/4c612b126d894ababe57d79be1540f64/icon-green-lock.svg" alt="Lock icon"/>
                    <span className="divider">|</span>
                    <span>https</span><span className="link-text">://booking.busabout.com/</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default React.memo(SecurePopup);



// WEBPACK FOOTER //
// ./src/components/shared/securePopup.js